const Sage = window.Sage;

export default {
  validate(formEl) {
    let errors = [];

    const inputs = formEl.find('.form-field__input.required');

    inputs.each((_i, input) => {
      input = $(input);

      let isFieldError = false;

      switch (input.attr('type')) {
        case 'checkbox':
          if (!input.is(':checked')) {
            errors.push(input.attr('name'));
            isFieldError = true;
          }
          break;

        default:
          if (!input.val()) {
            errors.push(input.attr('name'));
            isFieldError = true;
          }
      }

      const errorEl = input.closest('.form-field').find('.form-field__error');

      if (isFieldError) {
        input.addClass('error');
        errorEl.text(Sage.form.input_empty);
      } else {
        input.removeClass('error');
        errorEl.text('');
      }
    });

    return errors.length ? false : true;
  },
};
